import { type FC, type ReactNode, createContext, useContext } from 'react';

export interface DonorDetailBlockProps {
    introText: string;
    baseURL: string;
    detailForm: {
        formID: string;
        locale: string;
    };
    debitForm: {
        formID: string;
        locale: string;
    };
    thankYouPageUrl: string;
    paymentPageIntro: string;
    privacyLink: {
        enable: boolean;
        linkText: string;
        linkUrl: string;
        openNewTab: boolean;
    };
    paymentStepTitle: string;
    paymentStepSubtitle: string;
}

interface DonorDetailProviderProps extends DonorDetailBlockProps {
    children: ReactNode;
}

export const DonorDetailBlockContext = createContext<Partial<DonorDetailBlockProps>>({});

export const useDonorBlockProps = (): Partial<DonorDetailBlockProps> => {
    return useContext(DonorDetailBlockContext);
};

const DonorDetailBlockProvider: FC<DonorDetailProviderProps> = ({ children, ...resProps }) => {
    const providerValue = { ...resProps };

    return (
        <DonorDetailBlockContext.Provider value={providerValue}>
            {children}
        </DonorDetailBlockContext.Provider>
    );
};

export default DonorDetailBlockProvider;
